import { render } from "./IncidentDetails.vue?vue&type=template&id=63693792&scoped=true"
import script from "./IncidentDetails.vue?vue&type=script&lang=js"
export * from "./IncidentDetails.vue?vue&type=script&lang=js"

import "./IncidentDetails.vue?vue&type=style&index=0&id=63693792&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63693792"]])

export default __exports__